import { combineReducers } from "redux";
import appState from "./modules/appState";
import statisticsState from "./modules/bvaStatisticsTool";
import capitalizationOfEarnings from "./modules/capitalizationOfEarnings";
import capitalizationRate from "./modules/capitalizationRate";
import discountedCFM from "./modules/discountedCFM";
import forecastCashToEarning from "./modules/forecastCashToEarning";
import forecastDepreciation from "./modules/forecastDepreciation";
import forecastFCF from "./modules/forecastFCF";
import forecastGWC from "./modules/forecastGWC";
import forecastMGC from "./modules/forecastMGC";
import forecastRC from "./modules/forecastRC";
import growthForecastStageDCF from "./modules/growthForecastStageDCF";
import taxes from "./modules/taxes";
import user from "./modules/user";
import financials from "./modules/financials";
import tables from "./modules/tables";
import financingCalculator from "./modules/financingCalculator";
import acquisitionExpenses from "./modules/acquisitionExpenses";
import financialRatios from "./modules/financialRatios";
import qualityOfEarnings from "./modules/qualityOfEarnings";
import valuation from "./modules/valuation";
import dealOffer from "./modules/dealOffer";
import waterfall from "./modules/waterfall";
import category from "./modules/category";
import reports from "./modules/reports";
import generalData from "./modules/generalData";

const appReducer = combineReducers({
  appState,
  statisticsState,
  capitalizationOfEarnings,
  capitalizationRate,
  discountedCFM,
  forecastCashToEarning,
  forecastDepreciation,
  forecastGWC,
  forecastMGC,
  forecastRC,
  growthForecastStageDCF,
  taxes,
  user,
  financials,
  tables,
  financingCalculator,
  forecastFCF,
  acquisitionExpenses,
  financialRatios,
  qualityOfEarnings,
  valuation,
  dealOffer,
  waterfall,
  category,
  reports,
  generalData
});

const rootReducer = (state, { type, payload }) => {
  if (type === 'REPLACE_STATE' && payload && typeof payload === 'object') return payload;
  else return appReducer(state, { type, payload });
};

export default rootReducer;
